import Vue from "vue"
import App from "./App.vue";
import router from "./router";
import VueProgressiveImage from 'vue-progressive-image'
import LanguageService from "@/services/LanguageService";
const _ = require('lodash');

Vue.use(VueProgressiveImage);
window._ = _;
Vue.prototype.$throttle = _.throttle;

Vue.config.productionTip = false;

LanguageService.init();
Object.defineProperty(Vue.prototype, "$lang", {
	get: function $lang() {
		return LanguageService.getLanguage();
	}
});

const app = new Vue({
	router,
	data: {
		loading: false
	},
	render: h => h(App)
}).$mount('#app');

router.beforeEach((to, from, next) => {
	app.loading = true;
	next();
})

router.afterEach(() => {
	setTimeout(() => app.loading = false, 500);
})
